(function(){
  // rotating promo bar
  var msgs = document.querySelectorAll('#promo .msg'), pi = 0;
  if (msgs.length > 1) {
    setInterval(function(){
      msgs[pi].classList.remove('on');
      pi = (pi + 1) % msgs.length;
      msgs[pi].classList.add('on');
    }, 3800);
  }

  // hero slider
  var track = document.getElementById('htrack');
  if (track && track.children.length > 1) {
    var slides = track.children.length, hi = 0,
        dotsC = document.getElementById('hdots'), hero = document.getElementById('hero');
    for (var i = 0; i < slides; i++) {
      (function(i){
        var d = document.createElement('button');
        if (i === 0) d.className = 'on';
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function(){ go(i); });
        dotsC.appendChild(d);
      })(i);
    }
    var dots = dotsC.children;
    function go(n){
      hi = (n + slides) % slides;
      track.style.transform = 'translateX(-' + (hi * 100) + '%)';
      for (var i = 0; i < dots.length; i++){ dots[i].className = (i === hi ? 'on' : ''); }
    }
    track.addEventListener('focusin', function(e){ var s = e.target.closest('.hslide'); if (!s) return; hero.scrollLeft = 0; go(Array.prototype.indexOf.call(track.children, s)); });
    var nx = document.getElementById('hnext'), pv = document.getElementById('hprev');
    if (nx) nx.addEventListener('click', function(){ go(hi + 1); });
    if (pv) pv.addEventListener('click', function(){ go(hi - 1); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches, timer;
    function play(){ if (reduce) return; timer = setInterval(function(){ go(hi + 1); }, 5500); }
    function stop(){ clearInterval(timer); }
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    play();
  }
})();
